import { useEffect } from 'react';
import Navbar from '@/components/feature/Navbar';
import SeoTitle from '@/components/SeoTitle';
import PageJsonLd from './components/PageJsonLd';
import HeroSection from './components/HeroSection';
import RoiCtaBanner from './components/RoiCtaBanner';
import WhyCompaniesDontUnderstand from './components/WhyCompaniesDontUnderstand';
import WhatIsEffectivenessEvaluation from './components/WhatIsEffectivenessEvaluation';
import KirkpatrickModel from './components/KirkpatrickModel';
import KPITable from './components/KPITable';
import TrainingROI from './components/TrainingROI';
import RoiCalculator from './components/RoiCalculator';
import TypicalMistakes from './components/TypicalMistakes';
import WhyEmployeesForget from './components/WhyEmployeesForget';
import HowIEvaluate from './components/HowIEvaluate';
import CompanyResults from './components/CompanyResults';
import WhyWorkWithMe from './components/WhyWorkWithMe';
import CTASection from './components/CTASection';
import FAQSection from './components/FAQSection';
import SEOTextBlock from './components/SEOTextBlock';
import ReadNextSection from './components/ReadNextSection';
import Footer from '@/components/feature/Footer';

const navLinks = [
  { label: 'Что это', target: 'what-is' },
  { label: 'Киркпатрик', target: 'kirkpatrick' },
  { label: 'KPI', target: 'kpi' },
  { label: 'ROI', target: 'roi' },
  { label: 'Калькулятор ROI', target: 'roi-calculator', highlight: true },
  { label: 'Ошибки', target: 'mistakes' },
  { label: 'FAQ', target: 'faq' },
];

export default function EvaluationPage() {
  useEffect(() => {
    if (window.location.hash === '#roi-calculator') {
      const el = document.getElementById('roi-calculator');
      if (el) {
        window.setTimeout(() => el.scrollIntoView({ behavior: 'smooth', block: 'start' }), 150);
      }
    }
  }, []);

  return (
    <>
      
      <SeoTitle title="Оценка эффективности обучения | Business Training" />
      <PageJsonLd />
      <div className="min-h-screen bg-white font-['Inter']">
        <Navbar
          links={navLinks}
          ctaLabel="Заказать тренинг"
          ctaTarget="contact"
        />
        <HeroSection />
        <RoiCtaBanner />
        <WhyCompaniesDontUnderstand />
        <div id="what-is">
          <WhatIsEffectivenessEvaluation />
        </div>
        <div id="kirkpatrick">
          <KirkpatrickModel />
        </div>
        <div id="kpi">
          <KPITable />
        </div>
        <div id="roi">
          <TrainingROI />
        </div>
        <div id="roi-calculator">
          <RoiCalculator />
        </div>
        <div id="mistakes">
          <TypicalMistakes />
        </div>
        <WhyEmployeesForget />
        <HowIEvaluate />
        <div id="results">
          <CompanyResults />
        </div>
        <WhyWorkWithMe />
        <CTASection />
        <FAQSection />
        <SEOTextBlock />
        <ReadNextSection />
        <Footer />
      </div>
    </>
  );
}